const CityShowcase = () => import('@/modules/cityShowcase');

export default [
  {
    path: '/vitrine-cidade',
    component: CityShowcase,
    name: 'store-city-showcase',
    meta: {
      navbarTitle: 'Vitrine da Cidade',
      isAvaliableInMenu: true,
      menuData: {
        title: 'Vitrine da Cidade',
        id: 'cityShowcaseSidebar',
        section: 'Operação',
        icon: 'heart',
      },
    },
  },
];
